export const userSessionTokenCookieName = 'DSI_USER_ACCT_TOKEN';
